import request from '../../utils/Request';
import { Methods } from '../../config';

const baseURL = 'wms/base';

const wmsBaseService = {
  getData: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data,
    });
  },

  createData: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  updateData: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteData: (id, wmsType) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
      data: { wmsType },
    });
  },

  getRow: (id, data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/getHead/${encodeURIComponent(id)}`,
      data,
    });
  },

  createLine: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/line`,
      data,
    });
  },

  updateLine: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/line`,
      data,
    });
  },

  deleteLine: (id, wmsType) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/line/${encodeURIComponent(id)}`,
      data: { wmsType },
    });
  },

  getLinesByHeadId: (wmsHeadId, data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/line/head/${encodeURIComponent(wmsHeadId)}`,
      data,
    });
  },

  getBaseViewByWmsId: (baseId, data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/view/base/${encodeURIComponent(baseId)}`,
      data,
    });
  },

  generateTargetDoc: (wmsHeadId, data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/generateTargetDoc/${encodeURIComponent(wmsHeadId)}`,
      data,
    });
  },

  getOpenedDocs: (documentType) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/openDocs/${encodeURIComponent(documentType)}`,
    });
  },
};

export default wmsBaseService;
